<template>
  <div class="wrapper">
    <public-title rolename="角色名" @gotobtn="btn" @gotoinquire="eventinquire" :isbtn="true" btnname="新增"
      icon="el-icon-plus">
    </public-title>
    <div class="content">
      <el-table :data="tabledata" style="width: 100%" >
        <el-table-column prop="roleName" label="角色名" align="center">
        </el-table-column>
        <el-table-column prop="roleCode" label="角色编码" width="180" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column prop="description" label="备注" align="center">
        </el-table-column>
        <el-table-column label="操作" width="250" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="edit(scope.$index, scope.row)">修改</el-button>
            <el-button size="mini" type="primary" style="background: #014196;border-color: #014196" @click="jurisdiction(scope.$index, scope.row)">设置权限</el-button>
            <!-- <el-popconfirm icon="el-icon-info" v-model="DelVisible" confirmButtonText='确定' cancelButtonText='取消'
              @onConfirm="handleDelete(scope.$index, scope.row)" iconColor="red" style="margin-left: 10px;"
              title="您确定要删除这一条记录吗？"> -->
              <el-button slot="reference" size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            <!-- </el-popconfirm> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[15, 30, 40, 50]" :page-size="100" layout="total, sizes, prev, pager, next, jumper"
        :total="totals">
      </el-pagination>
    </div>
    <el-dialog :title="issubbtn?'新增角色':'修改角色'" :before-close="handleClose" :visible.sync="dialogVisible" width="35%">
      <el-form ref="form" :model="subform"  :rules="rules" label-width="80px">
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="subform.roleName"></el-input>
        </el-form-item>
        <el-form-item label="角色编码" prop="roleCode">
          <el-input v-model="subform.roleCode"></el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="description">
          <el-input type="textarea" v-model="subform.description"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" @click="onSubmit('form')">保存</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="设置权限" :before-close="handleClose1" :visible.sync="dialogVisible1" width="35%">
      <el-tree
        :data="limits"
        show-checkbox
        :default-expanded-keys="keys"
        :default-checked-keys="keys"
        node-key="id"
        ref="tree"
        @check-change="handleCheckChange"
        :props="defaultProps">
      </el-tree>

      <div style="text-align: right;margin: 10px 0;">
        <el-button type="primary" @click="jurisdictionSave()">保存</el-button>
        <el-button @click="dialogVisible1 = false">取消</el-button>
      </div>

    </el-dialog>
  </div>
</template>
<script>
  import publicTitle from '../../../components/publicTitle'
  export default {
    components: { publicTitle },
    props: {},
    data() {
      return {
        defaultProps: {
          children: 'childrens',
          label: 'name'
        },
        tabledata: [],
        currentPage: 1,
        pageSize: 15,
        pageIndex: 1,
        totals: 0,
        form: {},
        subform:{
          roleName:'',//角色名称
          roleCode:'',//	角色编码
          description:'',//	角色描述
        },
        DelVisible: false,
        dialogVisible: false,
        dialogVisible1:false,
        rules: {
          roleName: [
            { required: true, message: '请输入角色名称', trigger: 'blur' },
          ],
          roleCode: [
            { required: true, message: '请输入角色编码', trigger: 'blur' },
          ],
        },
        issubbtn:false, // edit fals - add true
        listid:'',
        limits:[],
        keys:[], //默认选中的节点
        defaultMenuIds: [], // 默认勾选的节点id
        selectNodeIds: [] // 选中的节点的id
      };
    },
    computed: {
    },
    mounted() {
      this.updata()
    },
    methods: {
      handleCheckChange() {
        this.selectNodeIds = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys());
      },
      updata(pageIndex = 1, pageSize = 15, Vrolename = '') {
        this.$http({
          url: this.$api.rolelists + `?pageIndex=${pageIndex}&pageSize=${pageSize}&roleName=${Vrolename}`,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            this.tabledata = res.data.data.records
            this.pageSize = res.data.data.size
            this.currentPage = res.data.data.current
            this.totals = res.data.data.total
          }
        });
      },
      eventinquire(form) {
        this.form = form
        this.updata(1, this.pageSize, this.form.Vrolename)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.updata(this.pageIndex, this.pageSize, this.form.Vrolename)
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.updata(this.pageIndex, this.pageSize, this.form.Vrolename)
      },
      edit(index, item) {
        this.dialogVisible = true;
        this.issubbtn = false
        this.listid = item.id
        this.subform.roleName = item.roleName
        this.subform.roleCode = item.roleCode
        this.subform.description = item.description
      },
      //设置权限
      jurisdiction(index, item){
        console.log(item,'11')
        this.listid = item.id
        this.$http({
          url: this.$api.permissiontree,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            console.log(res.data.data,'22')
            this.limits = res.data.data
            this.$forceUpdate();
            this.$http({
              url: this.$api.rolepermission + `${item.id}`,
              method: "GET",
            }).then(res => {
              if (res.data.code == 200) {
                console.log(res.data)
                this.keys = []
                this.keys = res.data.data;
                this.selectNodeIds = this.keys;
                this.$forceUpdate();
                this.dialogVisible1 = true;
              }else{
                this.$toast("error", res.data.msg);
              }
            });
          }else{
            this.$toast("error", res.data.msg);
          }
        });
      },
      btn(){
        this.subform.roleName = ''
        this.subform.roleCode = ''
        this.subform.description = ''
        this.dialogVisible = true
        this.subform.name = ''
        this.issubbtn = true
      },
      //删除
      handleDelete(index, item) {
        this.$confirm("您确定要删除这一条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: this.$api.roledel + `${item.id}`,
          method: "DELETE",
        }).then(res => {
          if (res.data.code == 200) {
            this.$toast("success", res.data.msg);
            this.updata(1, this.pageSize , this.form.Vrolename)
          }else{
            this.$toast("error", res.data.msg);
          }
          this.DelVisible = false
        });
      })
        
      },
      jurisdictionSave(){
        console.log("this.selectNodeIds",this.selectNodeIds)
        var data = {
          ids:this.selectNodeIds,
        }
        this.$http({
          url: this.$api.rolesaves + `${this.listid}`,
          method: "POST",
          data
        }).then(res => {
          if (res.data.code == 200) {
            this.$toast("success", res.data.msg);
            console.log('更新')
            this.keys = [];
            this.selectNodeIds = [];
            this.updata(this.pageIndex, this.pageSize, this.form.Vrolename)
            this.dialogVisible1 = false
            this.limits = []
          }else{
            this.$toast("error", res.data.msg);
          }
        })
      },
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let userId = JSON.parse(sessionStorage.getItem("userinfo")).id
            if(this.issubbtn){
              let data = {
                userId,
                roleName:this.subform.roleName,//角色名称
                roleCode:this.subform.roleCode,//	角色编码
                description:this.subform.description,//	角色描述
              }
              this.$http({
                url: this.$api.rolesave,
                method: "POST",
                data
              }).then(res => {
                if (res.data.code == 200) {
                  this.$toast("success", res.data.msg);
                  this.updata(1, this.pageSize , this.form.Vrolename)
                  this.dialogVisible = false
                  this.$refs['form'].resetFields();
                }else{
                  this.$toast("error", res.data.msg);
                }
              })
            } else {
              let data = {
                userId,
                id:this.listid,//角色id
                roleName:this.subform.roleName,//角色名称
                roleCode:this.subform.roleCode,//	角色编码
                description:this.subform.description,//	角色描述
              }
              this.$http({
                url: this.$api.roleupdate,
                method: "PUT",
                data
              }).then(res => {
                if (res.data.code == 200) {
                  this.$toast("success", res.data.msg);
                  this.updata(this.pageIndex, this.pageSize, this.form.Vrolename)
                  this.dialogVisible = false
                  this.$refs['form'].resetFields();
                }else{
                  this.$toast("error", res.data.msg);
                }
              })
            }
          } else {
            return false;
          }
        });
      },
      handleClose(done) {
        this.dialogVisible = false;
        this.$refs['form'].resetFields();
      },
      handleClose1(done) {
        this.keys = []
        this.dialogVisible1 = false;
      },
    },
    created() { },
    beforeDestroy() { }
  };
</script>

<style lang="scss" scoped>
  .role-select {
    width: 290px !important;
  }

  .content {
    background: #fff;
    width: 100%;
    height: 100%;
  }

  /deep/.el-pagination {
    text-align: center;
    padding: 10px 0;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }
    .wrapper{
    height: 100%;

  }
  /deep/.el-table{
      // overflow-x: scroll;
}
/deep/.el-table::before{
  background-color: none;
  opacity:0;
}
/deep/.el-table__body-wrapper{
  height:63vh;
  overflow: auto;
}
/deep/.el-table th>.cell{
  color: #000;
}
</style>